import { detectBrandId, getBrandConfig } from '../../brands/brands';

/**
 * Получить API URL из конфигурации бренда
 * Эта функция определяет текущий бренд и возвращает его API URL
 */
export function getApiUrl(): string {
  const brandId = detectBrandId();
  const brandConfig = getBrandConfig(brandId);
  return brandConfig.apiUrl;
}

/**
 * Глобальная переменная для кеширования API URL
 * Инициализируется при первом вызове getApiUrl()
 */
let cachedApiUrl: string | null = null;

/**
 * Получить закешированный API URL (для производительности)
 * При первом вызове определяет бренд и кеширует URL
 */
export function getCachedApiUrl(): string {
  if (!cachedApiUrl) {
    cachedApiUrl = getApiUrl();
  }
  return cachedApiUrl;
}

/**
 * Сбросить кеш API URL (полезно при смене бренда)
 */
export function resetApiUrlCache(): void {
  cachedApiUrl = null;
}






